module.exports = __webpack_public_path__ + "img/Nitrous & Sedation.e5801d46.png";